import messages from './messages'
import DateTools from 'utils/dates/dateTools'
import Colors from 'utils/colors/colors'

function getMetaFlag(dp) {
  if ( dp.meta && dp.meta.flag ) {
    return dp.meta.flag;
  }
  return null;
}

const formatLinesSeries = ({ data, name, color, startingYear, endingYear, dashedLine = false, gender = 'Total', formatMessage }) => {
  let values = [];

  let orderedData = data.data.sort((a, b) => { return a.time > b.time ? 1 : -1} );
  console.log(orderedData);
  orderedData.forEach(item => {
    if (DateTools.getYearFromDateString(item.time) >= startingYear && DateTools.getYearFromDateString(item.time) <= endingYear) {
      if ( item.value != null ) {
        let flag_note = getMetaFlag( item );

        values.push({
          x: DateTools.getYearFromDateString(item.time),
          y: item.value,
          notes: flag_note
        });
      }
    }
  })

  let markerEnabled = false
  if (values.length < 2) markerEnabled = true

  let dashStyle = 'Solid'
  if (gender !== 'Total') {
    if (gender === 'Male') {
      if (dashedLine) {
        dashStyle = 'Dot'
      } else {
        dashStyle = 'ShortDot'
      }
    } else {
      if (dashedLine) {
        dashStyle = 'LongDashDot'
      } else {
        dashStyle = 'ShortDashDot'
      }
    }
  } else {
    if (dashedLine) {
      dashStyle = 'Dash'
    } else {
      dashStyle = 'Solid'
    }
  }

  let lineName = name
  if (gender === 'Male') {
    lineName = `${name} (${formatMessage(messages.maleAcronym)})`
  }
  if (gender === 'Female') {
    lineName = `${name} (${formatMessage(messages.femaleAcronym)})`
  }

  return {
    name: lineName,
    color: Colors.colorToRGBA(color),
    data: values,
    dashStyle: dashStyle,
    marker: {
      enabled: markerEnabled
    }
  }
}

const linesChartAdapter = {
  formatLinesSeries
}
export default linesChartAdapter



// WEBPACK FOOTER //
// ./src/modules/Charts/Lines/LinesChart/LinesChartAdapter.js